export class CourseModel {
    id?: number;
    name: string;
    icon?: string;
    is_available: boolean;
    source_language: string;
    translation_language: string;
    bundle_link?: string;
}

export class AvailableCourseModel {
    id?: number;
    name: string;
    is_available: boolean;
    source_language: string;
    translation_language: string;
}
